// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  padding: var(--spacing-small-plus) var(--spacing-medium);
}

h2 {
  margin: var(--spacing-small) 0;
}

mat-dialog-content {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

mat-dialog-actions {
  gap: var(--spacing-medium);
}

button {
  padding: 0 var(--spacing-medium);
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/dialog.common.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,wDAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;AACF;;AAEA;EACE,0BAAA;AACF;;AAEA;EACE,gCAAA;AACF","sourcesContent":[":host {\n  display: block;\n  padding: var(--spacing-small-plus) var(--spacing-medium);\n}\n\nh2 {\n  margin: var(--spacing-small) 0;\n}\n\nmat-dialog-content {\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n\nmat-dialog-actions {\n  gap: var(--spacing-medium);\n}\n\nbutton {\n  padding: 0 var(--spacing-medium);\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
